module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/babel-runtime/regenerator/index.js
// module id = 23
// module chunks = 168707334958949